import React, { Component, useState } from 'react';
import Slider from "react-slick";

import SectionTitle from '../../components/SectionTitle'
import SingleEvent from '../../components/Event/SingleEvent';
import bgImage from '../../assets/images/hero/indian-642055_1920@2x.png'
import events from '../../data/Events.json';

const GovPartner = ({industryPartnerList}) => {
    const eventSettings = {
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                }
            },
            {

                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    arrows: false,
                }
            }
        ]
    };
    // const industryPartners=[
    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png",

    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png",

    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png",

    //     "./img/partners/industry-1.png",
    //     "./img/partners/industry-2.png",
    //     "./img/partners/industry-3.png",
    //     "./img/partners/industry-4.png", 

    // ];

    return (
        <div className="react-upcoming__event blog__area py-5 mb-5" style={{background:"none"}}>
            <div className="container">
                {/* <SectionTitle Title="Our  " subtitle="Partners" /> */}
                <h2 className='text-center mb-1 mt-4' style={{fontWeight:"600"}}>Industry Partners</h2>
                <p className=' py-2 text-center' style={{ fontWeight: "600" }}>
                Our strong ties with industry partners ensure that Ocfit’s curriculum remains relevant and aligned with current market needs. Collaborating with leading companies, we provide not only employment opportunities but also equip individuals with practical skills for successful careers in their chosen fields.
                </p>

                <div className="event-slider owl-carousel wow animate__fadeInUp" data-wow-duration="0.3s">
                    <Slider {...eventSettings}>
                        {industryPartnerList?.map((item, index) => {
                            return (
                                <div key={index} className='col p-2'>
                                <div className='rounded-3 d-flex justify-content-center align-items-center' style={{border:"1px solid black",height:"130px"}} >
                                 <img src={item?.logoUrl} width={102} height={102} className='' style={{objectFit:"cover",width:"55%",height:"55%"}}/>
                                </div>
                               </div>
                            //     <div key={index} className='col p-2'>
                            //     <img src={item} className='img-fluid'/>
                            // </div>
                            )
                        }).slice(0, 6)}
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default GovPartner;